/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import { EyeIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Bucket } from '../../types';

interface BucketActionMenuProps {
    bucket: Bucket;
    position: { top: number; right: number };
    onView: () => void;
    onEdit: () => void;
    onDelete: () => void;
    onClose: () => void;
}

const BucketActionMenu: React.FC<BucketActionMenuProps> = ({
    bucket,
    position,
    onView,
    onEdit,
    onDelete,
    onClose,
}) => {
    return (
        <>
            <div className="fixed inset-0 z-40" onClick={onClose}></div>
            <div
                className="fixed z-50 w-40 bg-gray-900 rounded-lg shadow-xl border border-gray-700 py-1"
                style={{
                    top: position.top,
                    right: position.right,
                }}
            >
                <button
                    onClick={onView}
                    className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:bg-gray-800 flex items-center gap-2"
                >
                    <EyeIcon className="w-4 h-4" />
                    View/Edit
                </button>
                <button
                    onClick={onDelete}
                    className="w-full px-4 py-2 text-left text-sm text-red-400 hover:bg-red-500/10 flex items-center gap-2"
                >
                    <TrashIcon className="w-4 h-4" />
                    Delete
                </button>
            </div>
        </>
    );
};

export default BucketActionMenu;
